// extracted by mini-css-extract-plugin
export default {"container":"Mode_container__G+lqy","mode":"Mode_mode__meudF","icon":"Mode_icon__3gIgO","label":"Mode_label__8RtI0"};